import "react-datepicker/dist/react-datepicker.css";
import "./i18n/i18n";

import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import { config } from "./config/config";
import { configureStore } from "./redux/store";

const client = new ApolloClient({
  uri: config.backendUrl,
  cache: new InMemoryCache({
    typePolicies: {
      User: {
        keyFields: ["userId"],
        merge(existing, incoming) {
          // Merge User objects by combining all fields from both existing and incoming
          return { ...existing, ...incoming };
        },
      },
      Query: {
        fields: {
          User: {
            merge(existing, incoming) {
              // Merge User objects in Query.User field by combining all fields
              return { ...existing, ...incoming };
            },
          },
        },
      },
    },
  }),
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <ApolloProvider client={client}>
    <Provider store={configureStore({})}>
      <React.Fragment>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <App />
        </BrowserRouter>
      </React.Fragment>
    </Provider>
  </ApolloProvider>
);
